import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, {
    createFilterOptions
} from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Checkbox, Chip, Popper } from "@mui/material";
import clsx from "clsx";
import useClasses from "../common/useClasses";

interface Props {
    items: { label: string; value: string }[]
    label: any
    placeholder?: any
    selectAllLabel: any
    limitTags: any
    optionalProps?: any
    initialDefaultValue: { label: string; value: string }[],
    popperWidth?:any,
    isPopperStyle?:any,
    onChange: (e: any) => void,
    onFocus? : (e:any)=>void
}


const useStyles = ((theme:any) => ({
  popperStyle: {
    left: "150px !important",
    "& .MuiAutocomplete-listbox": {
      padding: 0,
    },
    zIndex: 9999999,
  }
}));
const MultiSelectDropdown: React.FC<Props> = (props: Props) => {
const classes = useClasses(useStyles);
    const [selectedOptions, setSelectedOptions] = useState<
        { label: string; value: string }[]
    >([]);

    const allSelected = props.items?.length === selectedOptions.length;
    const handleToggleOption = (selectedOptions: any) =>
        setSelectedOptions(selectedOptions);
    const handleClearOptions = () => setSelectedOptions([]);
    const getOptionLabel = (option: any) => `${option.label}`;

    const handleSelectAll = (isSelected: any) => {
        if (isSelected) {
            setSelectedOptions(props.items);

        } else {
            handleClearOptions();
        }
    };

    const handleToggleSelectAll = () => {
        handleSelectAll && handleSelectAll(!allSelected);
    };

    const handleChange = (event: any, selectedOptions: any, reason: any) => {
        console.log('selectedOptions-->',selectedOptions,reason)
        if (reason === "selectOption" || reason === "removeOption") {
            if (selectedOptions.find((option: any) => option.value === "select-all")) {
                handleToggleSelectAll();
                let result = [];
                result = !allSelected ? props.items.filter((el: any) => el.value !== "select-all") : [];

                return props.onChange(result);


            } else {
                handleToggleOption && handleToggleOption(selectedOptions);
                return props.onChange(selectedOptions);
            }
        } else if (reason === "clear") {
            handleClearOptions && handleClearOptions();
            return props.onChange([]);
        }
    };
    const optionRenderer = (Iprops:any,option: any, { selected }: any) => {
        
        const { key, ...optionProps } = Iprops;

        const selectAllProps =
            option.value === "select-all" // To control the state of 'select-all' checkbox
                ? { checked: allSelected }
                : {};
        return (
            <li key={key} {...optionProps}>
                <Checkbox
                    color="primary"
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    // {...selectAllProps}
                />
                {
                    props.optionalProps?.countryWithFlag ?
                        <>
                            {
                                option.value === "select-all" ? getOptionLabel(option) :
                                    <>
                                        {option?.htmlTag ? <div dangerouslySetInnerHTML={{ __html: option.htmlTag }} /> :
                                            <span className="badge bg-primary-country" >
                                                <i className={`dropdown-flag-icon flag flag-${getOptionLabel(option).toLowerCase()}`} ></i>
                                                <span className="dropdown-flag-label">{getOptionLabel(option)}</span></span>
                                        }
                                    </>
                            }

                        </>
                        :
                        <>
                            {
                                option?.htmlTag ? <div dangerouslySetInnerHTML={{ __html: option.htmlTag }} /> : getOptionLabel(option)
                            }

                        </>
                }

            </li>
        );
    };


    useEffect(() => {

        const modifiedValue: any = props?.items?.length > 0 && props?.initialDefaultValue?.length > 0 ? props.items
            .map((res) => {
                if (
                    props?.initialDefaultValue?.some((response: any) => {
                        if (response.value === res.value) {
                            return res
                        }
                    })
                ) {
                    return res
                }
            })
            .filter(Boolean) : []

        setSelectedOptions(modifiedValue)


    }, [props?.initialDefaultValue])

    const inputRenderer = (params: any) => {
        return <TextField {...params} label={props.label} variant="outlined" placeholder={selectedOptions?.length > 0 ? null : props.placeholder} />
    };
    const getOptionSelected = (option: any, anotherOption: any) => option.value === anotherOption.value;
    const filter = createFilterOptions();
    return (
        <Autocomplete
            multiple
            {...props.optionalProps}
            limitTags={parseInt(props.limitTags)}
            options={props?.items ? props.items : []}
            value={selectedOptions || []}
            getOptionLabel={getOptionLabel}
            // getOptionSelected={getOptionSelected}
            isOptionEqualToValue={getOptionSelected}
            filterOptions={(options, params: any): any => {
                const filtered = filter(options, params);
                return [{ label: props.selectAllLabel, value: "select-all" }, ...filtered];
            }}
            onChange={handleChange}
            onFocus={(event:any)=>{
                props.onFocus && props.onFocus(event)
            }}
            renderOption={optionRenderer}
            PopperComponent={(popperRef: any) => {
                if(props?.isPopperStyle){
                    return (
                        <Popper
                          {...popperRef}
                          className={clsx(classes.popperStyle,'multiselect-input-popper-style-custom')}
                          style={{ width: props?.popperWidth }}
                        >
                          {" "}
                          {popperRef.children}{" "}
                        </Popper>
                    );
                }else{
                    return  <Popper
                    {...popperRef} >
{popperRef.children}
                    </Popper>
                }
                
              }}
            renderTags={(value, getTagProps) =>
                value.map((option: any, index) => {
                    return props.optionalProps?.countryWithFlag ?
                        <Chip
                            variant="outlined"
                            label={option?.htmlTag ? <div dangerouslySetInnerHTML={{ __html: option.htmlTag }} /> :
                                <span className="badge bg-primary-country" >
                                    <i className={`dropdown-flag-icon flag flag-${option.label.toLowerCase()}`} ></i>
                                    <span className="dropdown-flag-label">{option.label}</span></span>
                            }
                            size="small"
                            {...getTagProps({ index })}
                        />
                        :
                        <Chip 
                            variant="outlined"
                            label={option?.htmlTag ? <div dangerouslySetInnerHTML={{ __html: option.htmlTag }} /> : option.label}
                            size="small"
                            {...getTagProps({ index })}
                        />
                })
            }
            renderInput={inputRenderer}
        />
    );
};

export default MultiSelectDropdown;
